// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';

const clientInfoSetup = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if (to.meta.isLoginRoute || to.meta.cdo || to.meta.publicRoute) {
    next();

    return;
  }

  if (!store.state.user.current?.cl_user_id) await store.dispatch('profile/getClientInfo', null, {root: true});

  next();
};

export default clientInfoSetup;
